
import { Button } from "@/components/ui/button"
import { ArrowUpDown } from "lucide-react"
import { SortButtonProps } from "@/types/user-management"

export const SortButton = ({ field, label, currentField, direction, onSort }: SortButtonProps) => (
  <Button
    variant="ghost"
    onClick={() => onSort(field)}
    className="hover:bg-muted flex items-center gap-1"
  >
    {label}
    <ArrowUpDown className="h-4 w-4" />
  </Button>
)
